// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__28XWz","overlay":"styles_overlay__26rQw"};